const animation_marker_observeres = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0.1) {
        entry.target.classList.add('is-active');
        animation_marker_observeres.unobserve(entry.target);
      }
    })
  },{
    root: null,
    rootMargin: "0% 0% -10% 0%",
    threshold: 0.3,
  });

  const animation_marker_trigger = document.querySelectorAll(".dbp-e-marker.has-animation");
  animation_marker_trigger.forEach(e => {
    animation_marker_observeres.observe(e);
  });


document.addEventListener('DOMContentLoaded',() => {

	// animation ========================================
	const animation_observeres = new IntersectionObserver((entries) => {
		entries.forEach(entry => {

		if (entry.intersectionRatio > 0.1) {

			const target = entry.target;

			animation_observeres.unobserve(target);

			const animation = target.dataset.animation;

			const animation_args = JSON.parse(animation);

			const delay = animation_args?.delay?animation_args.delay:'0';
			const duration = animation_args?.duration?animation_args.duration:'300';


			const style = {
				animationName: animation_args?.name,
				animationTimingFunction: animation_args?.curve,
				animationDelay: `${delay}ms`,
				animationDuration:`${duration}ms`,
			};

			Object.assign(target.style, style);

			// target.style.animationName = animation_args?.name;
			// target.style.animationTimingFunction = animation_args?.curve;
			// target.style.animationDelay = `${delay}ms`;

			// target.style.animationDuration = `${duration}ms`;
			target.classList.add('is-animated');

			if(animation_args?.tochild){
				
				const childElements = Array.from(target.children).filter(
                    (child) => !child.hasAttribute('data-animation')
                );

				let childCount = 2;
				let childDelay = delay?delay:'100';

				childElements.forEach((child) => {

					style.animationDelay =  `${childDelay*childCount}ms`;
					Object.assign(child.style, style);
					childCount++;

                });

			}


							// setTimeout(function(){ 
				// 	// target.style.opacity = 1;
				// 	target.style.transition = `${duration}ms`;
				// }, delay);

				// target.style.opacity = 1;

				// animation-name: bounceLeft;

				// animation-iteration-count: 1;

				// opacity: 1;

				
				// const currentTime = new Date();

				// const start = target.dataset.periodStart;
				// const end = target.dataset.periodEnd;

				// if (start) {

				// 	const periodStartDate = new Date(start);

				// 	if (periodStartDate > currentTime) {
				// 		// return;
				// 		target.remove();
				// 		return;
				// 	}

				// }

				// if (end) {

				// 	const periodEndDate = new Date(end);

				// 	if (periodEndDate < currentTime) {
				// 		// return;
				// 		target.remove();
				// 		return;
				// 	}

				// }
				

		}
		})
	},{
		root: null,
		rootMargin: "-30% 0px -30% 0px",
		threshold: [0,0.1],
	});

	const animation_trigger = document.querySelectorAll("[data-animation]");
	animation_trigger.forEach(e => {
		animation_observeres.observe(e);
	});

});